// extracted by mini-css-extract-plugin
export default {"labelContainer":"fieldLabel_labelContainer__LFpb5","label":"fieldLabel_label__esrks"};